// Requisite auto-disable thresholds: empty means "no limit" (null on the backend).
export const autoDisableToInput = (value?: number | null) => (value ? String(value) : '');

export const autoDisableFromInput = (text?: string | null): number | null => {
  const digits = (text ?? '').replace(/[^0-9]/g, '');
  const value = Number(digits);
  return digits && value > 0 ? value : null;
};

export const formatAutoDisable = (value?: number | null) => (value ? String(value) : '—');

// Only send a threshold the form actually showed: a hidden table column leaves the field undefined.
export const autoDisablePayload = (successes?: string, timeouts?: string) => ({
  ...(successes !== undefined ? { auto_disable_after_successes: autoDisableFromInput(successes) } : {}),
  ...(timeouts !== undefined ? { auto_disable_after_timeouts: autoDisableFromInput(timeouts) } : {}),
});

export const AUTO_DISABLE_HINT = 'Пусто — без ограничения';
